<div class="header" [style.backgroundColor]="util?.configuration?.headerColor || null">
  <div>
    <div class="brand inline">
      <button aria-label="{'Menu' | translate}" (click)="menu.toggleSidebar()" class="d-sm-block d-md-block d-lg-none btn btn-link ">
        <app-icon [name]="'icon-menu'"></app-icon>
      </button>
      <img class="brand-header-img" (click)="menu.goToDefaultTool()" alt="logo"
        [src]="util?.darkMode ? util?.configuration?.externalLogoImageInvert : util?.configuration?.externalLogoImage">
    </div>
    <ul class="d-lg-inline-block d-none notification-list no-margin b-grey b-l b-r no-style p-l-15 p-r-15">
      @if (menu?.hasChatPod && util?.hasUserChat) {
      <li class="inline header-btn">
        <a aria-label="{'Mensagens' | translate}" routerLink="/message" matIconButton matTooltip="{{ 'Mensagens não lidas' | translate }}" matTooltipPosition="below">
          <svg-icon class="header-icon" src="https://publicfiles.mybeehome.com/icons/tools/chat-coret.svg" [svgStyle]="{'width.px': 21, 'height.px': 21}" [style.--icon-stroke]="util?.configuration?.fontColor"></svg-icon>@if
          (menu?.unreadedMessages > 0) {
          <span class="bubble bg-complete">
            <div class="count">{{menu?.unreadedMessages > 99 ? '+99' : menu?.unreadedMessages}}</div>
          </span>
          }
        </a>
      </li>
      }
     
      <li class="inline">
        <a aria-label="{'Notificações' | translate}" (click)="showNotifications()" matIconButton matTooltip="{{ 'Notificações' | translate }}" matTooltipPosition="below">
          <svg-icon class="header-icon" src="https://publicfiles.mybeehome.com/icons/tools/bell-coret.svg" [svgStyle]="{'width.px': 21, 'height.px': 21}" [style.--icon-stroke]="util?.configuration?.fontColor"></svg-icon>
          @if (notificationCenterService?.countUnseenNotifications) {
          <span class="bubble bg-danger">
            <div class="count">{{notificationCenterService?.countUnseenNotifications > 99 ? '+99' :
              notificationCenterService?.countUnseenNotifications}}</div>
          </span>
          }
        </a>
      </li>

      @if (menu?.hasLinksPod) {
      <li class="inline">
        <mat-menu #appMenu="matMenu">
          <ng-template matMenuContent>
            @if (linksLoading) {
            <a class="dropdown-item" mat-menu-item disabled>
              {{ 'Carregando...' | translate }}
            </a>
            }
            @for (link of favoriteLinks; track $index) {
            <a class="dropdown-item" mat-menu-item (click)="saveLinkUserHistory(link)">
              {{ link?.title | translate }}
            </a>
            }
            @if (!linksLoading && (!favoriteLinks || favoriteLinks.length === 0)) {
            <a class="dropdown-item" mat-menu-item disabled>
              {{ 'Não possui links mais acessados.' | translate }}
            </a>
            }
          </ng-template>
        </mat-menu>
        <a class="dropdown-item" matIconButton [matMenuTriggerFor]="appMenu" #trigger="matMenuTrigger"
          (menuOpened)="loadLinksOnce()" matTooltip="{{ 'Links mais acessados' | translate }}" matTooltipPosition="below">
          <svg-icon class="header-icon" src="https://publicfiles.mybeehome.com/icons/tools/link-coret.svg" [svgStyle]="{'width.px': 21, 'height.px': 21}" [style.--icon-stroke]="util?.configuration?.fontColor"></svg-icon>
        </a>
      </li>
      }

    </ul>

    @if (ps.podHeader && ps.podHeader?.podSocial && ps.podHeader?.id > 0) {
    <a class="d-lg-inline-block d-none b-r b-grey p-l-20 p-r-10  p-b-15 p-t-15" (click)="goToPod(ps.podHeader)">
      @if (ps.podHeader?.podType === 'customLink' || ps.podHeader?.podType === 'urlIntegration' ||
      ps.podHeader?.podType === 'wikiPage' || ps.podHeader?.podType === 'blogPost' || ps.podHeader?.podType ===
      'internalLink') {
      <svg-icon class="header-icon" [src]="'https://publicfiles.mybeehome.com/icons/custom-pods/'+ps.podHeader?.icon" [svgStyle]="{'width.px': 21, 'height.px': 21}" [style.--icon-stroke]="util?.configuration?.fontColor"></svg-icon>

      }
      @if (ps.podHeader?.podType !== 'customLink' && ps.podHeader?.podType !== 'urlIntegration' &&
      ps.podHeader?.podType !== 'wikiPage' && ps.podHeader?.podType !== 'blogPost' && ps.podHeader?.podType !==
      'internalLink') {
      <svg-icon class="header-icon" [src]="'https://publicfiles.mybeehome.com/icons/default-pods/'+ps.podHeader?.podType+'.svg'" [svgStyle]="{'width.px': 21, 'height.px': 21}" [style.--icon-stroke]="util?.configuration?.fontColor"></svg-icon>
      }
      @if (menu.loggedUser.preferredLocale === 'pt-BR') {
      <span class="search-link" [style.color]="util?.configuration?.fontColor">{{
        ps.podHeader?.title }}</span>
      }
      @if (menu.loggedUser.preferredLocale === 'pt-PT') {
      <span class="search-link" [style.color]="util?.configuration?.fontColor">{{ps.podHeader?.ptTitle}}</span>
      }
      @if (menu.loggedUser.preferredLocale === 'en-US') {
      <span class="search-link" [style.color]="util?.configuration?.fontColor">{{ps.podHeader?.enTitle}}</span>
      }
      @if (menu.loggedUser.preferredLocale === 'es-ES') {
      <span class="search-link" [style.color]="util?.configuration?.fontColor">{{ps.podHeader?.esTitle}}</span>
      }
    </a>
    }

    <a class="d-lg-inline-block d-none m-l-10" [style.color]="util?.configuration?.fontColor"
      (click)="searchToggle()">
      <svg-icon class="header-icon top-1" src="https://publicfiles.mybeehome.com/icons/tools/icon-search-4.svg" [svgStyle]="{'width.px': 18, 'height.px': 18}" [style.--icon-stroke]="util?.configuration?.fontColor"></svg-icon>
      <span class="search-link ">{{'Encontre o que quiser...' | translate}}</span>
    </a>


  </div>
  <div class="dropdown d-flex align-items-center" dropdown #profileDropdown="bs-dropdown" (onShown)="onShown()">
    <a class="d-flex align-items-center" dropdownToggle id="profileDropdown">
      <div class="pull-left p-r-10 fs-13 font-heading m-l-20 d-none d-sm-block ">
        @if (menu.loggedUser?.socialName) {
        <div>
          <span class="semi-bold" [style.color]="util?.configuration?.fontColor">{{menu.loggedUser?.socialName}}</span>
          &nbsp;@if (menu.loggedUser?.verified) {
          <app-icon [name]="'verified-symbol'"></app-icon>
          }
        </div>
        }
        @if (!menu.loggedUser?.socialName) {
        <div>
          <span class="semi-bold"
            [style.color]="util?.configuration?.fontColor">{{menu.loggedUser?.firstName}}</span>&nbsp;
          <span [style.color]="util?.configuration?.fontColor">{{menu.loggedUser?.lastName}}</span>&nbsp;
          @if (menu.loggedUser?.verified) {
          <app-icon [name]="'verified-symbol'"></app-icon>
          }
        </div>
        }

        @if (menu?.hasCachedAwardPod() && menu?.loggedUser?.award) {
        <div class="award-badge-pic-only" [ngStyle]="{'background':  menu?.loggedUser?.award?.initialGradient}">
          {{menu?.loggedUser?.award?.year}}
          @if (menu?.loggedUser?.award?.year > 1) {
          <span>{{'anos' | translate}}</span>
          }
          @if (menu?.loggedUser?.award?.year == 1) {
          <span>{{'ano' | translate}}</span>
          }
        </div>
        }
      </div>
      <div class="pull-right d-lg-block">
        <div class="user-display">
          <div class="relative profile-dropdown-toggle">
            <div class="user-pic-only"
              [ngStyle]="{'background-image': (menu.loggedUser?.award && menu?.hasCachedAwardPod()) ? 'linear-gradient(to right, ' + menu?.loggedUser?.award?.initialGradient +', '+ menu?.loggedUser?.award?.finalGradient+')' : 'none'}"
              [ngClass]="{'award-pic-only': menu.loggedUser?.award && menu?.hasCachedAwardPod()}">
              <app-user-avatar [user]="menu.loggedUser" [size]="32"></app-user-avatar>
              @if (menu.loggedUser?.profileThemeTO?.imageS3URL) {
              <img
                [ngClass]="{'theme-profile-award': menu.loggedUser?.award && menu?.hasCachedAwardPod(), 'theme-profile': !(menu.loggedUser?.award && menu?.hasCachedAwardPod())}"
                loading=lazy src="{{menu.loggedUser?.profileThemeTO?.imageS3URL}}" alt="">
              }
            </div>
            @if (menu?.hasChatPod && util?.hasUserChat && !util?.configuration?.disableChatBar) {
            <span class="user-availability-status-indicator"
              [ngStyle]="{ 'background-color': cs.currentChatUserAvailabilityStatus?.chatAvailabilityStatus?.colorHex || '#29cc6a', left: menu.loggedUser?.award ? '30px' : '25px' }"></span>
            }
          </div>
        </div>

        <div class="dropdown-menu dropdown-menu-right profile-dropdown" *dropdownMenu role="menu">
          <div class="dropdown-scroll" [perfectScrollbar]="util?.scrollconfig">

            <!-- Status do usuário -->
            @if (menu?.hasChatPod && util?.hasUserChat && !util?.configuration?.disableChatBar &&
            cs.currentChatUserAvailabilityStatus?.userId === menu?.loggedUserId) {
            <a class="dropdown-item d-flex align-items-center" (click)="openChatAvailabilityStatusModal()">
              <span class="availability-color-dot" style="opacity: 1.0 !important;"
                [ngStyle]="{ 'background-color': cs.currentChatUserAvailabilityStatus?.chatAvailabilityStatus?.colorHex || '#29cc6a' }">
              </span>
              <div class="ml-2 flex-grow-1">
                <div class="hint-text">
                  {{ cs.currentChatUserAvailabilityStatus?.chatAvailabilityStatus?.title }}
                </div>
                @if (cs.currentChatUserAvailabilityStatus?.expiresOn) {
                <small class="text-muted">
                  {{ 'Expira em' | translate }}
                  {{ cs.currentChatUserAvailabilityStatus?.expiresOn |
                  date:'short':util?.userTimeZone:util.translate.getCurrentLang() }}
                </small>
                }
              </div>
              <app-icon [name]="'icon-chevron-right'" [size]="10"></app-icon>
            </a>
            <div class="dropdown-divider"></div>
            }

            @if (menu?.loggedUserId) {
            <a class="dropdown-item hint-text" [routerLink]="'/directory/'+menu?.loggedUserId+'/profile'"
              [state]="{object: menu?.loggedUser}">{{'Meu Perfil' | translate}}</a>
            }
            @if (ds.avaliableAvatars.length > 0 && !menu?.loggedUser?.avatar) {
            <a class="dropdown-item hint-text" (click)="selectAvatarToogle()">{{'Usar como Avatar' |
              translate}}</a>
            }
            @if (menu?.loggedUser?.avatar) {
            <a class="dropdown-item hint-text" (click)="selectAvatarToogle()">{{'Retornar a seu usuário' |
              translate}}</a>
            }
            <a class="dropdown-item hint-text" (click)="editLocaleToogle()">{{'Idioma' | translate}}</a>
            @if ((!util?.configuration?.cognitoSSO || (util?.configuration?.cognitoSSO && util?.isMFA)) &&
            !menu?.loggedUser?.avatar) {
            <a class="dropdown-item hint-text" (click)="editPasswordToogle()">{{'Alterar Senha' | translate}}</a>
            }
            @if (!util.isPushNotificationsEnabled) {
            <a class="dropdown-item hint-text" (click)="repromptForNotifications()">{{'Habilitar Notificações' |
              translate}}</a>
            }

            <ng-container>
              @if (menu?.isAdministrator || menu?.managerDashboard || newsManager) {
              <div class="dropdown-divider"></div>
              }
              @if (menu?.isAdministrator) {
              <a class="dropdown-item hint-text" routerLink="/insights">{{'Insights' | translate}}</a>
              }
              @if (menu?.isAdministrator || menu?.managerDashboard) {
              <a class="dropdown-item hint-text" routerLink="/analytics/dashboard/audit">{{'Auditoria' | translate}}</a>
              }
              @if (menu?.isAdministrator) {
              <a class="dropdown-item hint-text" routerLink="/pod">{{'Ferramentas' | translate}}</a>
              }
              @if (menu?.isAdministrator || chatbotManager) {
              <a class="dropdown-item hint-text" routerLink="/chatbot/admin/manager">{{'Chatbot' | translate}}</a>
              }
              @if (menu?.isAdministrator) {
              <a class="dropdown-item hint-text" routerLink="/notification">{{'Enviar Notificação' | translate}}</a>
              }
              @if (menu?.isAdministrator) {
              <a class="dropdown-item hint-text" routerLink="/notificationWhatsapp">{{'Notificação via Whatsapp' |
                translate}}</a>
              }
              @if (menu?.isAdministrator) {
              <a class="dropdown-item hint-text" routerLink="/permissions">{{'Permissões' | translate}}</a>
              }
              @if (menu?.isAdministrator) {
              <a class="dropdown-item hint-text" routerLink="/integration">{{'Integrações' | translate}}</a>
              }
              @if ((menu?.isAdministrator || newsManager)) {
              <a class="dropdown-item hint-text" routerLink="/newsletter">{{'Newsletter' | translate}}</a>
              }
              @if (menu?.isAdministrator || welcomeScreenManager) {
              <a class="dropdown-item hint-text" routerLink="/welcomeScreen">{{'Pop-up Informativo' | translate}}</a>
              }
              @if ((menu?.isAdministrator || videowallManager)) {
              <a class="dropdown-item hint-text" routerLink="/videowall">{{'Videowall' | translate}}</a>
              }
              @if (menu?.isAdministrator) {
              <a class="dropdown-item hint-text" routerLink="/system/admin">{{'Configurações' | translate}}</a>
              }
            </ng-container>
            <div class="dropdown-divider"></div>
            <div class="form-check form-check-inline switch dropdown-item">
              <input type="checkbox" id="pagesSwitch" [(ngModel)]="darkMode" (change)="toggleDarkMode()">
              <label class="fs-12 hint-text p-t-3" for="pagesSwitch">{{'Modo Escuro' | translate}}</label>
            </div>
            <div class="dropdown-divider p-l-20"></div>
            @if (menu?.consentmentTermUser?.consentmentTerm) {
            <a (click)="openConsentmentTerm()" class="dropdown-item hint-text">{{'Termos de Uso' | translate}}</a>
            }
            <a class="dropdown-item  hint-text" routerLink="/privacy">{{'Política de Privacidade' |
              translate}}</a>
            <a class="dropdown-item  hint-text" (click)="showCookieSlider()">{{'Política de Cookies' |
              translate}}</a>
            <div class="dropdown-divider"></div>
            <a (click)="auth.logout()" class="dropdown-item hint-text">{{'Sair' | translate}}</a>
          </div>
        </div>
      </div>
    </a>
  </div>
</div>
<app-search-overlay></app-search-overlay>
<app-notification-center #notificationCenter></app-notification-center>
<app-error-modal #errorModal [message]="'Ocorreu um erro de serviço.'" [reloadButton]="false"></app-error-modal>
<div bsModal #editLocaleModal="bs-modal" class="modal fade stick-up" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-md">
    <div class="modal-content bg-contrast-lowest">
      <div class="modal-header clearfix text-left">
        <button type="button" class="close" (click)="editLocaleModal.hide()" aria-hidden="true" aria-label="{{'Fechar' | translate}}">
        </button>
        <h5 class="full-width">{{'Alterar idioma' | translate}}</h5>
      </div>
      <div class="modal-body">
        <form [formGroup]="localeForm">
          <div [ngClass]="{'disabled' : savingLocale}"
            [class.has-error]="getFormControl('preferredLocale', localeForm).invalid && (  getFormControl('preferredLocale', localeForm).dirty || getFormControl('preferredLocale', localeForm).touched)"
            class="form-group form-group-default form-group-default-select2 required" appFormGroup>
            <label>{{'Idioma' | translate}}</label>
            <ng-select class="form-control" bindLabel="name" [searchable]="false" formControlName="preferredLocale"
              [addTag]="false" [multiple]="false" [hideSelected]="false" [clearable]="false">
              @for (item of util.availableLocalesList; track item) {
              <ng-option [value]="item.locale">
                {{item.name}}
              </ng-option>
              }
            </ng-select>
            <app-icon [name]="'icon-info'" [color]="'light'"
              matTooltip="{{'Selecione em qual idioma a plataforma será exibida' | translate}}"
              matTooltipPosition="above"></app-icon>
          </div>
          @if (getFormControl('preferredLocale', localeForm).invalid && ( getFormControl('preferredLocale',
          localeForm).dirty || getFormControl('preferredLocale', localeForm).touched)) {
          <div class="error-wrapper">
            <label class="error">{{'Campo obrigatório' | translate}}</label>
          </div>
          }
        </form>
        <div class="row m-t-20 sm-m-t-10">
          <div class="col-md-12 text-right">
            <button type="button" class="btn btn-success btn-cons text-center" (click)="editLocale()"
              [disabled]="savingLocale">
              {{ savingLocale ? ('Salvando'| translate) : 'Salvar' | translate}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div bsModal #editPasswordModal="bs-modal" class="modal fade stick-up" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-md">
    <div class="modal-content bg-contrast-lowest">
      <div class="modal-header clearfix text-left">
        <button type="button" class="close" (click)="editPasswordModal.hide()" aria-hidden="true" aria-label="{{'Fechar' | translate}}">
        </button>
        <h5 class="full-width">{{'Alterar Senha' | translate}}</h5>
      </div>
      <div class="modal-body">
        <form [formGroup]="passwordForm">
          <div [ngClass]="{'disabled': savingPassword}" class="form-group form-group-default required">
            <label>{{ 'Senha atual' | translate }}</label>
            <div class="input-group">
              <input [type]="showPasswordCurrent ? 'text' : 'password'" class="form-control"
                placeholder="{{ 'Digite aqui sua senha' | translate }}" aria-label="{{ 'Digite aqui sua senha' | translate }}" formControlName="currentPassword" required>
              <div class="input-group-append" style="margin-top: -12px;">
                <img src="https://publicfiles.mybeehome.com/icons/tools/view.svg"
                  (click)="showPasswordCurrent = !showPasswordCurrent" [class.hide]="showPasswordCurrent" alt="">
                <img src="https://publicfiles.mybeehome.com/icons/tools/view-off.svg"
                  (click)="showPasswordCurrent = !showPasswordCurrent" [class.hide]="!showPasswordCurrent" alt="">
              </div>
            </div>
          </div>
          @if (getFormControl('currentPassword', passwordForm).valid && getFormControl('hasError', passwordForm).value
          && ( getFormControl('currentPassword', passwordForm).dirty || getFormControl('currentPassword',
          passwordForm).touched)) {
          <div class="error-wrapper">
            <label class="error">{{'Senha atual está incorreta' | translate}}</label>
          </div>
          }
          @if (getFormControl('currentPassword', passwordForm).invalid && ( getFormControl('currentPassword',
          passwordForm).dirty || getFormControl('currentPassword', passwordForm).touched)) {
          <div class="error-wrapper">
            <label class="error">{{'Campo obrigatório' | translate}}</label>
          </div>
          }
          <div class="form-group form-group-default required"
            [class.has-error]="getFormControl('newPassword', passwordForm).invalid && (getFormControl('newPassword', passwordForm).dirty || getFormControl('newPassword', passwordForm).touched)"
            appFormGroup>
            <label>{{'Nova Senha' | translate}}</label>
            <div class="input-group">
              <input [type]="showPasswordNew ? 'text' : 'password'" class="form-control" formControlName="newPassword"
                required placeholder="{{ 'Digite aqui a nova senha' | translate }}" aria-label="{{ 'Digite aqui a nova senha' | translate }}">
              <div class="input-group-append" style="margin-top: -10px;">
                <img src="https://publicfiles.mybeehome.com/icons/tools/view.svg"
                  (click)="showPasswordNew = !showPasswordNew" [class.hide]="showPasswordNew" alt="">
                <img src="https://publicfiles.mybeehome.com/icons/tools/view-off.svg"
                  (click)="showPasswordNew = !showPasswordNew" [class.hide]="!showPasswordNew" alt="">
              </div>
            </div>
            <hr>
            @if (passwordStrength.value!=null && passwordForm.value.newPassword !='') {
            <small>{{passwordStrength?.label
              | translate}}</small>
            }
            <password-strength-info [password]="passwordForm.value.newPassword"
              (checkPassword)="onStrengthChange($event)"></password-strength-info>
          </div>
          @if (getFormControl('newPassword', passwordForm).invalid && (getFormControl('newPassword', passwordForm).dirty
          || getFormControl('newPassword', passwordForm).touched)) {
          <div class="error-wrapper">
            <label class="error">{{'Campo obrigatório' | translate}}</label>
          </div>
          }
          <div class="form-group form-group-default required"
            [class.has-error]="(passwordForm?.get('repeatPassword').value != passwordForm?.get('newPassword').value || getFormControl('repeatPassword', passwordForm).invalid) && (getFormControl('repeatPassword', passwordForm).dirty || getFormControl('repeatPassword', passwordForm).touched)"
            appFormGroup>
            <label>{{'Repetir Senha' | translate}}</label>
            <div class="input-group">
              <input [type]="showPasswordRepeat ? 'text' : 'password'" class="form-control"
                formControlName="repeatPassword" required placeholder="{{ 'Repita aqui a nova senha' | translate }}" aria-label="{{ 'Repita aqui a nova senha' | translate }}">
              <div class="input-group-append" style="margin-top: -12px;">
                <img src="https://publicfiles.mybeehome.com/icons/tools/view.svg"
                  (click)="showPasswordRepeat = !showPasswordRepeat" [class.hide]="showPasswordRepeat" alt="">
                <img src="https://publicfiles.mybeehome.com/icons/tools/view-off.svg"
                  (click)="showPasswordRepeat = !showPasswordRepeat" [class.hide]="!showPasswordRepeat" alt="">
              </div>
            </div>
          </div>
          @if (getFormControl('repeatPassword', passwordForm).valid && passwordForm?.get('repeatPassword').value !=
          passwordForm?.get('newPassword').value && (getFormControl('repeatPassword', passwordForm).dirty ||
          getFormControl('repeatPassword', passwordForm).touched)) {
          <div class="error-wrapper">
            <label class="error">{{'Senhas não batem' | translate}}</label>
          </div>
          }
          @if (getFormControl('repeatPassword', passwordForm).invalid && (getFormControl('repeatPassword',
          passwordForm).dirty || getFormControl('repeatPassword', passwordForm).touched)) {
          <div class="error-wrapper">
            <label class="error">{{'Campo obrigatório' | translate}}</label>
          </div>
          }
          @if (passErrorBlackList) {
          <div class="error-wrapper">
            <label class="error">{{'A senha digitada possui uma palavra ou sequência mapeada em uma lista de sequências
              ou palavras não permitidas.' | translate}}</label>
          </div>
          }
          @if (weakPassword) {
          <div class="error-wrapper">
            <label class="error">{{'A senha está muito fraca, escolha uma senha mais forte.' | translate}}</label>
          </div>
          }
          @if (notAllowedPassword) {
          <div class="error-wrapper">
            <label class="error">{{'Senha já utilizada anteriormente' | translate}}</label>
          </div>
          }
        </form>
        <div class="row m-t-20 sm-m-t-10">
          <div class="col-md-12 text-right">
            <button type="button" class="btn btn-success btn-cons text-center" (click)="ediPassword()"
              [disabled]="savingPassword">
              {{ savingPassword ? ('Salvando'| translate) : 'Salvar' | translate}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-cookie-message #cookie></app-cookie-message>
<div bsModal #enablePush="bs-modal" class="modal fade stick-up" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title pull-left">{{'Habilitar Notificações' | translate}}</h4>
        <button type="button" class="close" (click)="enablePush.hide()" aria-hidden="true" aria-label="{{'Fechar' | translate}}"></button>
      </div>

      <div class="modal-body">
        <p>
          {{ 'Você bloqueou as notificações ou as ignorou anteriormente. Para receber atualizações importantes, siga os
          passos abaixo para habilitar novamente:' | translate }}
        </p>
        <ol>
          <li>
            {{'Clique no ícone de cadeado ou informação ao lado do endereço do site no seu navegador.' |
            translate}}
          </li>
          <li>
            {{'Selecione "Configurações do site" ou algo similar.' | translate}}
          </li>
          <li>
            {{'Localize "Notificações" e altere para "Permitir".' | translate}}
          </li>
          <li>
            {{'Atualize a página para que as configurações entrem em vigor.' | translate}}
          </li>
        </ol>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="enablePush.hide()">
          {{ 'Entendi' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<div bsModal #selectAvatarModal="bs-modal" class="modal fade stick-up" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content bg-contrast-lowest">
      <div class="modal-header clearfix text-left">
        <button type="button" class="close" (click)="selectAvatarModal.hide()" aria-hidden="true" aria-label="{{'Fechar' | translate}}">
        </button>
        <h5>{{'Selecionar Avatar' | translate}}</h5>
      </div>
      @if (!previousUser) {
      <div class="modal-body">
        <div class="row">
          <div class="col-md-6">
            <p class="over-title">{{'Seu usuário'|translate }}</p>
            <div class="form-group form-group-default form-group-default-select2 p-t-5 p-b-5" appFormGroup>
              <div class="card-body p-t-5 p-b-5">
                <app-user-display [lines]="'none'" [noLink]="true" [userObject]="menu.loggedUser">
                </app-user-display>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <p class="over-title">{{'Selecione o Avatar'|translate }}</p>
            <div class="form-group form-group-default form-group-default-select2 p-t-5 p-b-5" appFormGroup>
              <label>{{'Avatar'|translate}}</label>
              <ng-select class="form-control m-h-44" [maxSelectedItems]="1" [items]="ds.avaliableAvatars"
                [addTag]="false" [multiple]="false" [clearable]=false [searchable]="false"
                placeholder="{{'Selecione...' | translate}}" [(ngModel)]="avatar">
                <ng-template ng-label-tmp let-item="item" let-clear="clear">
                  <span class="ng-value-label">
                    <span>{{item?.socialName ? item?.socialName : (item?.fullName ? item?.fullName :
                      item?.name)}}</span>
                  </span>
                </ng-template>
                <ng-template ng-option-tmp let-item="item">
                  <app-user-display [userObject]="item" [noLink]="true"></app-user-display>
                </ng-template>
              </ng-select>
              <app-icon matTooltip="{{'Selecione o usuário.' | translate}}" matTooltipPosition="above" [name]="'icon-info'"
                [color]="'light'"></app-icon>
            </div>
          </div>
        </div>
        <div class="row m-t-20 sm-m-t-10">
          <div class="col-md-12 text-right">
            <button type="button" class="btn btn-success btn-cons text-center" (click)="selectAvatar()"
              [disabled]="savingPassword">
              {{ changingToFromAvatar ? ('Alterando'| translate) : 'Selecionar' | translate}}
            </button>
          </div>
        </div>
      </div>
      }
      @if (previousUser) {
      <div class="modal-body">
        <div class="row">
          <div class="col-md-5">
            <app-user-display [lines]="'none'" [noLink]="true" [userObject]="menu.loggedUser">
            </app-user-display>
          </div>
          <div class="col-md-2">
            <a class="m-l-10  full-height btn btn-complete" style="cursor: default;">
              <img src="https://publicfiles.mybeehome.com/icons/tools/chevron-right-double.svg" width="18" height="18"
                alt="">
            </a>
          </div>
          <div class="col-md-5">
            <app-user-display [lines]="'none'" [noLink]="true" [userObject]="previousUser">
            </app-user-display>
          </div>
        </div>
        <div class="row m-t-20 sm-m-t-10">
          <div class="col-md-12 text-right">
            <button type="button" class="btn btn-success btn-cons text-center" (click)="returnToUser()"
              [disabled]="savingPassword || changingToFromAvatar">
              {{ changingToFromAvatar ? ('Alterando'| translate) : ('Retornar a seu usuário' |
              translate)}}
            </button>
          </div>
        </div>
      </div>
      }
    </div>
  </div>
</div>

<div bsModal #editStatusModal="bs-modal" class="modal fade stick-up" tabindex="-1" role="dialog" aria-hidden="true"
  [config]="{backdrop: 'static', keyboard: false}">
  <div class="modal-dialog modal-sm">
    <div class="modal-content bg-contrast-lowest">
      <div class="modal-header clearfix text-left">
        <button type="button" class="close" (click)="editStatusModal.hide()" aria-hidden="true" aria-label="{{'Fechar' | translate}}"></button>
        <h5 class="full-width">{{'Definir disponibilidade' | translate}}</h5>
      </div>

      <div class="modal-body">
        <div class="list-group m-b-15">
          @for (status of chatAvailabilityStatusList; track status) {
          <button type="button" class="list-group-item list-group-item-action d-flex align-items-center"
            (click)="onSelectChatAvailabilityStatus(status)"
            [class.active]="selectedChatUserAvailabilityStatus?.id === status.id">
            <span class="availability-color-dot"
              [ngStyle]="{ 'background-color': status?.colorHex || '#29cc6a' }"></span>
            <span class="m-l-5">{{ status?.title | translate }}</span>
          </button>
          }
        </div>

        @if (!isDefaultAvailabilitySelected()) {
        <div class="form-group form-group-default">
          <label>{{'Definir mensagem de status' | translate}}</label>
          <textarea maxlength="100" type="text" rows="3" [(ngModel)]="selectedChatUserAvailabilityCustomMessage"
            class="form-control"></textarea>
          <app-icon [name]="'icon-info'" [color]="'light'"
            matTooltip="{{'Digite sua mensagem de status aqui' | translate}}"
            matTooltipPosition="above">
          </app-icon>
        </div>
        <div class="form-group form-group-default" appFormGroup>
          <label>{{'Expira em' | translate}}</label>
          <ng-select [items]="expiresOptions" bindLabel="label" bindValue="value" [(ngModel)]="expiresPreset"
            [clearable]="true" [searchable]="false" placeholder="{{'Selecione' | translate}}"
            (change)="onExpiresPresetChange()">
          </ng-select>
          <app-icon [name]="'icon-info'" [color]="'light'"
            matTooltip="{{'Defina por quanto tempo este status de disponibilidade ficará ativo' | translate}}"
            matTooltipPosition="above">
          </app-icon>
          @if (!isDefaultAvailabilitySelected() && selectedChatUserAvailabilityExpiresOn && expiresPreset !== 'custom')
          {
          <small class="hint-text">
            {{ selectedChatUserAvailabilityExpiresOn | date:'dd/MM/yyyy HH:mm' }}
          </small>
          }
        </div>
        @if (expiresPreset === 'custom') {
        <div class="form-group form-group-default" appFormGroup>
          <label>{{'Data de expiração' | translate}}</label>
          <input type="text" class="form-control m-r-10" [(ngModel)]="selectedChatUserAvailabilityExpiresDate"
            placeholder="{{'Data' | translate}}" aria-label="{{'Data' | translate}}" (ngModelChange)="updateCustomExpiresOn()"
            [minDate]="setMinAllowedDate()" bsDatepicker [container]="'body'" />
        </div>
        }
        @if (expiresPreset === 'custom') {
        <div class="form-group form-group-default" appFormGroup>
          <label>{{'Hora de expiração' | translate}}</label>
          <bh-timepicker [(ngModel)]="selectedChatUserAvailabilityExpiresTime" [disabled]="saving"
            (ngModelChange)="updateCustomExpiresOn()">
          </bh-timepicker>
        </div>
        }
        }

        <div class="d-flex justify-content-end" (click)="saveChatUserAvailabilityStatus()">
          <button type="button" class="btn btn-success">
            {{ 'Salvar' | translate }}
          </button>
        </div>

      </div>
    </div>
  </div>
</div>